import { useAuth } from "../../global-components/src";
import { GlobalAccount } from "../../global-components/src/components/global-account";
import { PACOCA_URL } from "../../global-components/src/utils/vars";

export function Account(){
    return (
        <>
            <div className="container container-conta">
                <div className="row justify-content-center">
                    <div className="col-md-8">
                        <GlobalAccount/>
                    </div>
                </div>
            </div>
        </>
    );
}